<div class="modal-header">
    <h4 class="modal-title">{{ 'InviteConfirmation' | translate }}</h4>
    <div>
        <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="activeModal.dismiss()"></i>
    </div>
</div>
<div class="modal-body">
    {{ 'InviteConfirmationMessage' | translate }} {{ user.dual_name }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">
        <i class="fe fe-x"></i>
        <span>{{ 'Cancel' | translate }}</span>
    </button>
    <button class="btn btn-sm btn-custom" [disabled]="(httpService.getLoading('inviteUserLoader'))" (click)="invite()">
        <ng-container *ngIf="(httpService.getLoading('inviteUserLoader'))">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span>{{ 'Inviting' | translate }}...</span>
        </ng-container>
        <ng-container *ngIf="!(httpService.getLoading('inviteUserLoader'))">
            <i class="fe fe-check"></i>
            <span>{{ 'Invite' | translate }}</span>
        </ng-container>
    </button>
</div>